var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStopRecord = function SvgStopRecord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    className: "stopRecord_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M512 76.8C271.36 76.8 76.8 271.36 76.8 512S271.36 947.2 512 947.2 947.2 752.64 947.2 512 752.64 76.8 512 76.8m0 793.6c-199.68 0-358.4-158.72-358.4-358.4S312.32 153.6 512 153.6 870.4 312.32 870.4 512 711.68 870.4 512 870.4",
    className: "stopRecord_svg__selected",
    "data-spm-anchor-id": "a313x.search_index.0.i10.46d13a81SNXjJl"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04437",
    d: "M307.2 409.6c0-56.32 46.08-102.4 102.4-102.4h204.8c56.32 0 102.4 46.08 102.4 102.4v204.8c0 56.32-46.08 102.4-102.4 102.4H409.6c-56.32 0-102.4-46.08-102.4-102.4z"
  })));
};
export default SvgStopRecord;